export default {"src":"/_next/static/media/close_white.83ee5aac.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};